import type { ITicketSuggestion } from '../../../../models/ticket-suggestion.model';
import { CurrencyHelper } from '../../../../helpers/currency.helper';
import { TranslationService } from '../../../../services/translation.service';
import { TravellerCategory } from '../../../../models/traveller-category.enum';
import { TicketSuggestionHelper } from '../../../../helpers/ticket-suggestion.helper';

function calculateTravellerCategoryPrice(ticketSuggestions: ITicketSuggestion[], travellerCategory: TravellerCategory): number | undefined {
  const validTicketSuggestions = ticketSuggestions
    .filter((ts) => ts.travellerCategory === travellerCategory && ts.priceInSek !== undefined)
    .filter((ts) => TicketSuggestionHelper.hasValidSalesChannelsAndTimeLimitation(ts));

  if (validTicketSuggestions.length === 0) {
    return undefined;
  }

  return validTicketSuggestions.reduce((prev, curr) => Math.min(prev, curr.priceInSek), validTicketSuggestions[0].priceInSek);
}

function LowestTicketPrices({ ticketSuggestions, priceDisclaimerId }: { ticketSuggestions: ITicketSuggestion[]; priceDisclaimerId: string }) {
  // === VARIABLES ===
  const adultPriceInSek = calculateTravellerCategoryPrice(ticketSuggestions, TravellerCategory.adult);
  const youthPriceInSek = calculateTravellerCategoryPrice(ticketSuggestions, TravellerCategory.youth);

  return (
    <div className="text-end">
      <div>
        {TranslationService.get('common.adult')}
        <span>: </span>
        <span className="fw-bold">
          {CurrencyHelper.toLocaleStringWithZeroOrTwoDigits(adultPriceInSek)}
          {adultPriceInSek ? (
            <span role="figure" aria-describedby={priceDisclaimerId}>
              **
            </span>
          ) : (
            <>
              <span aria-hidden>-</span>
              <span className="visually-hidden">{TranslationService.get('singleticket.nopriceavailable')}</span>
            </>
          )}
        </span>
      </div>
      <div>
        {TranslationService.get('common.youth')}
        <span>: </span>
        <span className="fw-bold">
          {CurrencyHelper.toLocaleStringWithZeroOrTwoDigits(youthPriceInSek)}
          {youthPriceInSek ? (
            <span role="figure" aria-describedby={priceDisclaimerId}>
              **
            </span>
          ) : (
            <>
              <span aria-hidden>-</span>
              <span className="visually-hidden">{TranslationService.get('singleticket.nopriceavailable')}</span>
            </>
          )}
        </span>
      </div>
    </div>
  );
}

export default LowestTicketPrices;
